module.exports = __webpack_public_path__ + "static/media/closed-captioning.0083db9e.svg";